
export const LIST_DEFAULT_PAGE = 1;
export const LIST_PAGINATION_RANGE = 5;
